// extracted by mini-css-extract-plugin
export default {"fileContainer":"BindingOfferModalContent_fileContainer__LJmW-"};